var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{style:(_vm.fixedHeight ? "height: 400px;overflow: auto" : "")},[_c('v-list',_vm._l((_vm.diagnoses),function(item,i){return _c('v-list-item',{key:i},[_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(item)}})],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }